module.exports = __webpack_public_path__ + "static/img/item2.78038ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/item2.png
// module id = 1/2b
// module chunks = 0